import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Buffer } from "buffer";
import disableDevtool from "disable-devtool";
window.Buffer = Buffer;

disableDevtool({
  md5: "", // Bỏ qua kiểm tra md5 nếu cần (mặc định không cần)
  url: "https://www.google.com", // URL chuyển hướng nếu tắt devtool thất bại
  tkName: "PIMAX", // Tên query string để bypass nếu cần (ví dụ: ?ddtk=xxx)
  interval: 200, // Tần suất kiểm tra (ms)
  disableMenu: true, // Chặn chuột phải
  stopIntervalTime: 10000, // Thời gian dừng theo dõi trên mobile sau x ms
  clearIntervalWhenDevOpenTrigger: true, // Không ngừng theo dõi khi phát hiện mở DevTool
  detectors: "all", // Bật tất cả detector
  clearLog: true, // Xóa console log mỗi lần kiểm tra
  //   disableSelect: true, // Chặn bôi đen
  //   disableCopy: true, // Chặn copy
  //   disableCut: true, // Chặn cut
  //   disablePaste: true, // Chặn paste
  ignore: null, // Không bỏ qua trường hợp nào
  disableIframeParents: true, // Ngăn dùng khi trong iframe
  timeOutUrl: "https://www.google.com", // URL nếu trang timeout
  rewriteHTML: "<h1>PIMAX Page blocked</h1>", // HTML hiển thị nếu devtool bị phát hiện

  // Callback khi mở DevTools
  ondevtoolopen: (type, next) => {
    console.warn(`DevTools bị mở với kiểu: ${type}`);
    next(); // Gọi nếu muốn đóng tab hiện tại
  },

  // Callback khi DevTools được đóng
  ondevtoolclose: () => {
    console.log("DevTools đã đóng");
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
